var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 843,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1201,
    height: 843
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1085.02 235.1C812.03 161.335 617.614-53.334 371.889 12.317 91.305 87.281-82.421 355.908 39.612 573.825c73.818 131.823 413.896 286.957 674.633 266.796C1079.7 812.362 1369.81 312.046 1085.02 235.1Z",
    fill: "red",
    fillOpacity: 0.73
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fill: "#3DB0F7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.281,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 1.214,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.281,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.855,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 64.363,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 32.788,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.281,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.855,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 127.511,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 95.937,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.281,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.855,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 190.659,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 159.085,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.281,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.855,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 253.807,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 222.233,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.281,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.855,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 316.955,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 285.381,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.28,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.854,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 380.104,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 348.529,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.28,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.854,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 443.252,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 411.678,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.28,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.854,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 506.4,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 474.826,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.281,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.855,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 569.548,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 537.974,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.281,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.855,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 632.697,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 601.122,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.281,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.855,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 695.845,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 664.271,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.281,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.855,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 758.993,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 727.419,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.502,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.076,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.651,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.224,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.799,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.373,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.947,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.521,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.095,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.669,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.243,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.818,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.391,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.965,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.54,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.114,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.688,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.262,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.836,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.41,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.985,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.558,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.133,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.707,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 783.281,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.855,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.429,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.003,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.577,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 941.151,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 972.725,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.3,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.87,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1067.45,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.02,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.6,
    cy: 790.567,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1162.17,
    cy: 822.141,
    r: 6.072
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1193.74,
    cy: 790.567,
    r: 6.072
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDots);
export default __webpack_public_path__ + "static/media/blue-dots.bb252ea0f8054780d4744ebb6d4a80d9.svg";
export { ForwardRef as ReactComponent };